<template>
    <div class="news">
        <siteHeader />
        <img src="@/assets/01.jpg" alt="main image" class="main-image">
        <div class="news-container">
            <div class="news-intro-card">
                <h2 class="card-title">项目研究 <span class="english-subtitle">Project Research</span></h2>
                <div class="news-content-area">
                    <div class="news-sidebar">
                        <!-- <h3>项目研究</h3> -->
                        <ul>
                            <li v-for="category in categories" :key="category.type"
                                @click="fetchProjects(category.type)"
                                :class="{ active: selectedCategory === category.type }">
                                {{ category.name }}
                            </li>
                        </ul>
                    </div>
                    <div class="news-content">
                        <!-- <h3>{{ selectedCategoryName }}</h3> -->
                        <div class="article-grid">
                            <div class="article-item" v-for="article in projectList" :key="article.id"
                                @click="viewProjectDetail(article)">
                                <img :src="article.cover" alt="Article Image" class="article-image">
                                <div class="article-info">
                                    <p class="article-date">{{ article.itemTime }}111</p>
                                    <h4 class="article-title">{{ article.title }}</h4>
                                </div>
                            </div>
                        </div>
                        <p v-if="!projectList || projectList.length === 0">暂无项目</p>

                        <div class="pagination">
                            <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">Previous</button>
                            <button v-for="page in totalPages" :key="page" @click="goToPage(page)"
                                :class="{ active: currentPage === page }">
                                {{ page }}
                            </button>
                            <button @click="goToPage(currentPage + 1)"
                                :disabled="currentPage === totalPages">Next</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <siteFooter />
    </div>
</template>

<script>
import siteHeader from '../components/SiteHeader.vue'
import siteFooter from '../components/SiteFooter.vue'
import { getProjectList } from '@/api/website'

export default {
    name: 'ProjectPage',
    components: {
        siteHeader,
        siteFooter
    },
    data() {
        return {
            categories: [
                { name: '项目研究', type: 1 }
            ],
            selectedCategory: 1, // Default to '项目研究'
            projectList: [],
            selectedCategoryName: '项目研究', // Default name
            currentPage: 1,
            itemsPerPage: 6,
            totalItems: 0
        }
    },
    mounted() {
        this.fetchProjects(this.selectedCategory, this.currentPage)
    },
    methods: {
        async fetchProjects(type, pageNum = 1) {
            this.selectedCategory = type;
            this.currentPage = pageNum;
            const selectedCat = this.categories.find(cat => cat.type === type);
            this.selectedCategoryName = selectedCat ? selectedCat.name : 'Project Research';
            try {
                const response = await getProjectList({ type: type, pageNum: pageNum, pageSize: this.itemsPerPage });
                if (response && response.code === 200) {
                    this.projectList = response.rows;
                    this.totalItems = response.total;
                } else {
                    this.projectList = [];
                    this.totalItems = 0;
                    console.error('Failed to fetch projects:', response.msg);
                }
            } catch (error) {
                this.projectList = [];
                this.totalItems = 0;
                console.error('Error fetching projects:', error);
            }
        },
        goToPage(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.fetchProjects(this.selectedCategory, page);
            }
        },
        viewProjectDetail(project) {
            this.$router.push({
                path: '/ProjectDetails',
                query: {
                    id: project.id,
                    type: 'project'
                }
            });
        }
    },
    computed: {
        totalPages() {
            return Math.ceil(this.totalItems / this.itemsPerPage);
        }
    }
}
</script>

<style scoped>
.main-image {
    width: 79.17%;
    max-width: 1520px;
    height: auto;
    display: block;
    margin: 0 auto;
}

.news-container {
    display: flex;
    padding: 20px;
    max-width: 1200px;
    margin: 20px auto;
    margin-top: -50px;
    flex-direction: column;
}

.news-intro-card {
    background: white;
    border-radius: 12px;
    padding: 32px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.news-intro-card .card-title {
    color: #ac6249;
    font-size: 24px;
    margin-bottom: 16px;
    padding-bottom: 8px;
    position: relative;
    display: inline-block;
}

.news-intro-card .card-title::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 2px;
    background-color: #ac6249;
}

.news-intro-card .english-subtitle {
    font-size: 20px;
    color: #666;
    font-weight: normal;
}

.news-content-area {
    display: flex;
    gap: 40px;
    margin-top: 20px;
}

.news-sidebar {
    width: 200px;
}

.news-sidebar ul {
    list-style: none;
    padding: 0;
}

.news-sidebar li {
    cursor: pointer;
    padding: 10px 15px;
    margin-bottom: 10px;
    background-color: #3c4a6b;
    color: white;
    border-radius: 4px;
    transition: background-color 0.3s ease, opacity 0.3s ease;
    text-align: center;
}

.news-sidebar li:hover {
    background-color: #2c3e50;
    opacity: 0.9;
}

.news-sidebar li.active {
    background-color: #ac6249;
    font-weight: bold;
}

.news-content {
    flex-grow: 1;
}

.article-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
}

.article-item {
    border: 1px solid #eee;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    cursor: pointer;
}

.article-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.article-image {
    width: 100%;
    height: 160px;
    object-fit: cover;
}

.article-info {
    padding: 15px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}

.article-date {
    font-size: 0.8em;
    color: #666;
    margin-bottom: 8px;
}

.article-title {
    font-size: 1em;
    margin-top: 0;
    margin-bottom: 0;
    color: #333;
    flex-grow: 1;
}

.pagination {
    margin-top: 20px;
    text-align: center;
}

.pagination button {
    margin: 0 5px;
    padding: 8px 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.pagination button:hover:not(:disabled) {
    background-color: #f0f0f0;
}

.pagination button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

.pagination button.active {
    background-color: #b4715b;
    color: white;
    border-color:#b4715b;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
    .main-image {
        width: 100%;
    }

    .news-container {
        padding: 15px;
        margin: 20px 10px;
        margin-top: -30px;
    }

    .news-intro-card {
        padding: 20px;
        border-radius: 8px;
    }

    .news-intro-card .card-title {
        font-size: 20px;
    }

    .news-intro-card .english-subtitle {
        font-size: 16px;
        display: block;
        margin-top: 5px;
    }

    .news-content-area {
        flex-direction: column;
        gap: 20px;
        margin-top: 15px;
    }

    .news-sidebar {
        width: 100%;
    }

    .news-sidebar h3 {
        font-size: 16px;
        margin-bottom: 10px;
    }

    .news-sidebar ul {
        display: flex;
        gap: 10px;
        overflow-x: auto;
        padding-bottom: 5px;
    }

    .news-sidebar li {
        min-width: 100px;
        flex-shrink: 0;
        padding: 8px 12px;
        margin-bottom: 0;
        font-size: 14px;
    }

    .news-content h3 {
        font-size: 18px;
        margin-bottom: 15px;
    }

    .article-grid {
        grid-template-columns: 1fr;
        gap: 15px;
    }

    .article-image {
        height: 180px;
    }

    .article-info {
        padding: 12px;
    }

    .article-title {
        font-size: 15px;
    }

    .article-date {
        font-size: 12px;
    }

    .pagination button {
        padding: 6px 12px;
        font-size: 14px;
        margin: 0 3px;
    }
}

@media screen and (max-width: 480px) {
    .news-container {
        padding: 10px;
        margin: 15px 5px;
        margin-top: -20px;
    }

    .news-intro-card {
        padding: 15px;
    }

    .news-intro-card .card-title {
        font-size: 18px;
    }

    .news-intro-card .english-subtitle {
        font-size: 14px;
    }

    .article-image {
        height: 150px;
    }

    .pagination button {
        padding: 5px 10px;
        font-size: 12px;
    }
}
</style>